import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer";
import MemberTable from "../Members/MembersTable";
import MemberForm from "../Members/MemberForm";
import { useGet } from "../../customHooks/useGet";
import { usePost } from "../../customHooks/usePost";
import { FaPlus, FaSearch } from "react-icons/fa";
import { useAuthProvider } from "../../customHooks/authContext";
import { Alert} from "react-bootstrap";

import { useLocation, useNavigate } from "react-router-dom";
const FloatingButton = ({ onClick, icon, title, position }) => (
  <button
    className="btn position-fixed rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
    onClick={onClick}
    aria-label={title}
    title={title}
    style={{
      background: "linear-gradient(135deg, #007bff, #6610f2)",
      color: "white",
      fontSize: "1.5rem",
      border: "none",
      width: "60px",
      height: "60px",
      transition: "transform 0.2s ease, box-shadow 0.3s ease",
      zIndex: 1050,
      bottom: "20px",
      right: position === "add" ? "20px" : "90px",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    {icon}
  </button>
);

function Members() {
  const location = useLocation();
  const navigate = useNavigate();
  const { school: contextSchool, token } = useAuthProvider();
  const { schoolselected } = location.state || {};

  console.log("schoolselected (raw):", schoolselected);

  const normalizedSchool =
  contextSchool?.id ? contextSchool
  : typeof schoolselected === "object"
    ? schoolselected
    : { id: Number(schoolselected)};

  const schoolId = normalizedSchool?.id;

  console.log("Normalized School:", normalizedSchool);
  console.log("schoolId:", schoolId);

  const API_BASE_URL_MEMBERS = schoolId
    ? `https://ectech-software.com.ar/api/academy/schools/${schoolId}/members`
    : null;

  const { data: membersData, loading, error, refetch } = useGet(
    API_BASE_URL_MEMBERS ? `${API_BASE_URL_MEMBERS}?page=0&size=10` : null
  );
  
  const { executePost } = usePost();
  const [members, setMembers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showHelpMessage, setShowHelpMessage] = useState(true); // Estado para el mensaje de ayuda

// 🔹 Ocultar el mensaje de ayuda después de 30 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHelpMessage(false);
    }, 10000); // 30 segundos

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    if (membersData?.content && Array.isArray(membersData.content)) {
      setMembers(membersData.content);
    } else if (Array.isArray(membersData)) {
      setMembers(membersData);
    }

  }, [membersData]);

  // Filtrar miembros por nombre o apellido
  const filteredMembers = members.filter(
    (member) =>
      member.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      member.surname.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCreateMember = async (newMember) => {
    try {
      if (!API_BASE_URL_MEMBERS) throw new Error("ID de escuela no disponible");

      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const createdMember = await executePost(API_BASE_URL_MEMBERS, newMember, config);
      if (!createdMember?.name || !createdMember?.surname) {
        throw new Error(`Respuesta inesperada: ${JSON.stringify(createdMember)}`);
      }

      // Recargar la lista de miembros después de agregar uno nuevo
      await refetch();
      setShowForm(false);
    } catch (error) {
      console.error("Error al crear el miembro:", error);
      alert(`Hubo un problema al crear el miembro. Detalles: ${error.message}`);
    }
  };

  return (
    <div className="container mt-4 pb-5">
      <h1 className="text-center">Gestión de Miembros</h1>
      {/* Mostrar mensaje de ayuda si showHelpMessage es true */}
      {showHelpMessage && (
        <Alert variant="danger" className="text-center">
          Ayuda: Aquí puedes gestionar los miembros, quienes pueden ser Alumnos /as y Profesores /as.
        </Alert>
      )}

      

      {showSearch && (
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar miembro..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            className="btn btn-primary search-btn"
            onClick={() => setSearchQuery("")}
            title="Limpiar búsqueda"
          >
            X
          </button>
        </div>
      )}

      {loading && <p className="alert alert-info text-center">Cargando miembros...</p>}
      {error && <p className="alert alert-danger text-center">Error al cargar miembros: {error.message}</p>}

      {!loading && !error && filteredMembers.length > 0 ? (
        <MemberTable members={filteredMembers} setMembers={setMembers} />
      ) : (
        <p className="text-center text-muted">No hay miembros disponibles.</p>
      )}

      {!showForm && (
        <>
          <FloatingButton
            onClick={() => setShowForm(true)}
            icon={<FaPlus size={24} />}
            title="Agregar nuevo miembro"
            position="add"
          />
          
        </>
      )}

      {showForm && (
        <div className="mt-4">
          <MemberForm onSubmit={handleCreateMember} setShowForm={setShowForm} />
        </div>
      )}

      <Footer />
    </div>
  );
}

export default Members;
